<template>
  <div class="clients">
    <div class="clients__title">Factures</div>

    <div class="clients__subtitle">Recherche factures</div>

    <FacturesCustomFilter :filters="filters" />

    <template v-if="isBusy">
      <Preloader />
    </template>
    <template v-else>
      <div class="clients__table">
        <template v-if="factures.data.length > 0">
          <div class="clients__table__item">
            <div class="clients__table__item--cell">Date</div>
            <div class="clients__table__item--cell small_wider">
              N° de facture
            </div>
            <div class="clients__table__item--cell">Montant</div>
            <div class="clients__table__item--cell icon-cell">Récépissé</div>
          </div>
          <div class="clients__table__item" v-for="facture in factures.data">
            <div class="clients__table__item--cell">
              {{ parseDate(facture.created_at) }}
            </div>
            <div class="clients__table__item--cell small_wider">
              {{ parseNum(facture) }}
            </div>
            <div class="clients__table__item--cell">
              {{ parseAmount(facture) }}
            </div>
            <div
              class="clients__table__item--cell icon-cell"
              v-if="getTypeInvoice(facture) == 'Facture'"
            >
              <font-awesome-icon
                prefix="fas"
                icon="file-pdf"
                @click="show_pdf(facture)"
              />
            </div>
            <div class="clients__table__item--cell icon-cell" v-else>
              <font-awesome-icon
                prefix="fas"
                icon="file-pdf"
                @click="show_credit(facture.quotes[0].id)"
              />
            </div>
          </div>
          <pagination
            :data="factures"
            @pagination-change-page="getFactures"
          ></pagination>
        </template>
      </div>
      <template v-else>
        <div class="subscribes-empty">
          Il n'y a aucun facture pour ce type de garantie à ce jour.
        </div>
      </template>
    </template>
    <template v-else>
      <Preloader />
    </template>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import FacturesCustomFilter from "@/components/Factures/FacturesCustomFilter";

export default {
  name: "FacturesTable",
  components: { Preloader, FacturesCustomFilter },
  data() {
    return {
      isBusy: false,
      factures: {
        data: [],
      },
      filters: {
        start_date: null,
        end_date: null,
        amount: "",
      },
    };
  },
  methods: {
    isDealer() {
      return this.$store.getters.isDealer;
    },
    getFactures() {
      this.isBusy = true;
      let url = this.isDealer() ? "invoices/dealer-search" : "invoices";
      this.apiGet(url, { ...this.parseFilter() })
        .then((res) => {
          this.isBusy = false;
          this.factures = res.data;
        })
        .catch((err) => {
          this.isBusy = false;
          this.showErrorNotification(err);
        })
        .finally(() => (this.isBusy = false));
    },
    parseDate(date) {
      return this.moment(date).format("DD/MM/YYYY");
    },
    parseAmount(invoice) {
      if (this.isDealer()) {
        let amount = 0;
        if (invoice && invoice.quotes && invoice.quotes.length > 0) {
          for (let i in invoice.quotes) {
            amount += invoice.quotes[i].price;
            amount += invoice.quotes[i].assistance_price || 0;
          }
        }
        return `${parseFloat(amount).toFixed(2)} €`;
      }
      return `${parseFloat(invoice.amount).toFixed(2)} €`;
    },
    parseNum(invoice) {
      if (!invoice.invoice_number.indexOf("A"))
        return "Avoir " + invoice.invoice_number;
      else if (!invoice.invoice_number.indexOf("I"))
        return "Facture " + invoice.invoice_number;
    },
    getTypeInvoice(invoice) {
      if (!invoice.invoice_number.indexOf("A")) return "Avoir";
      else return "Facture";
    },
    show_pdf(facture) {
      this.apiGet(
        `invoices/dealer-pdf?mechanic_id=${facture.mechanic.id}&invoice_number=${facture.invoice_number}`
      )
        .then((res) => {
          if (res.data.file_url) {
            window.open(this.$store.state.baseUrl + '/' + res.data.file_url, '_blank');
          }
        })
        .catch((err) => this.showErrorNotification(err))
        .finally(() => {});
    },
    show_credit(id) {
      this.refreshTokenForce()
        .then(
          () =>
            (window.location = this.getApiAuthUrl(`invoices/credit-pdf/${id}`))
        )
        .catch((error) => this.showErrorNotification(error));
    },
    parseFilter() {
      let data = {};
      if (this.filters.start_date) {
        data.start_date = this.filters.start_date;
        data.start_date.setHours(0, 0, 0, 0);
      }
      if (this.filters.end_date) {
        data.end_date = this.filters.end_date;
        data.end_date.setHours(23, 59, 59, 0);
      }
      if (this.filters.amount) data.amount = this.filters.amount;

      return data;
    },
  },
  mounted() {
    this.getFactures();
    this.$eventBus.$on("get-factures", this.getFactures);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Factures/Factures.vue